// extracted by mini-css-extract-plugin
export default {"root":"Box_root__PD7S5"};